import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetExtractTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setExtractTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
